var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"innerfooter"},[_c('div',{staticClass:"container"},[(_vm.merchant().ShowFooterLink)?_c('div',{staticClass:"footer-link",domProps:{"innerHTML":_vm._s(_vm.invoice_id_string)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }